import React from 'react';
import cx from 'classnames';

import { Label } from '@atlas/ui';

const Navigation = ({ activeType, onChange, types }) => {
  if (types.length === 1) {
    return null;
  }

  return (
    <div className="tabs-list">
      {types?.map(type => {
        const { title } = type;

        const elementClassName = cx('tab-list-item', {
          active: type === activeType,
        });

        return (
          <div className={elementClassName} key={title} onClick={() => onChange(type)}>
            <Label message={title} />
          </div>
        );
      })}
    </div>
  );
};

export default Navigation;
